const fs = require("fs");
const path = require("path");

const getCategoriesInfo = () => {
	const categoriesConfigPath = path.resolve
		? path.resolve(__dirname, "../../../../", "categoriesConfig.json")
		: null;
	let config = {};
	if (categoriesConfigPath && fs.existsSync(categoriesConfigPath)) {
		config = JSON.parse(fs.readFileSync(categoriesConfigPath, "utf-8"));
	}
	return config;
};

module.exports = getCategoriesInfo;
